import api from '../../api/deptIndicatorsRoutes.js';

const namespaced = true
 
const state = {
    departmentIndicators: [],
    departmentIndicatorsNot: [],
}

const mutations = {
    MUTATION_SET_DEPARTMENT_INDICATORS(state, data) {
        state.departmentIndicators = data.data;
    },
    MUTATION_SET_DEPARTMENT_INDICATORS_NOT(state, data) {
        state.departmentIndicatorsNot = data.data;
    },
    
    MUTATION_ADD_DEPARTMENT_INDICADORES(state, value) {
        state.departmentIndicatorsNot = state.departmentIndicatorsNot.filter(
            ind => ind.indi_id !== value.indicator.idIndicador
        );
        state.departmentIndicators.unshift(value);
    },
    MUTATION_UPDATE_DEPARTMENT_INDICADORES(state, updatedValue) {
        const index = state.departmentIndicators.findIndex(
            ind => ind.id === updatedValue.id
        );
        if (index !== -1) {
            state.departmentIndicators[index] = {
                ...state.departmentIndicators[index],
                ...updatedValue
            };
        }
    },
    MUTATION_DELETE_DEPARTMENT_INDICADORES(state, value) {
        const deletedItem = state.departmentIndicators.find(ind => ind.id === value);
        if (deletedItem) {
            state.departmentIndicators = state.departmentIndicators.filter(ind => ind.id !== value);
            const notAssigned = {
                indi_id: deletedItem.indicator.idIndicador, 
                indi_name: deletedItem.indicator.nom_indicador,
                indi_desc: deletedItem.indicator.desc_indicador,
                indi_unit: {
                    id: deletedItem.indicator.unidad.id,
                    name: deletedItem.indicator.unidad.nom_ind_unidad,
                    desc: deletedItem.indicator.unidad.desc_ind_unidad
                }
            };
            state.departmentIndicatorsNot.push(notAssigned);
        }
    },
}

const actions = {
    getID(context, id) {
        return new Promise((resolve, reject) => {
            api.getID(id).then(function (res) {
                if (res.status === 200) {
                    context.commit('MUTATION_SET_DEPARTMENT_INDICATORS', res.data);
                    resolve(res.data);
                } else {
                    reject(new Error(res.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    getIDNot(context, id) {
        return new Promise((resolve, reject) => {
            api.getIDNot(id).then(function (res) {
                if (res.status === 200) {
                    context.commit('MUTATION_SET_DEPARTMENT_INDICATORS_NOT', res.data);
                    resolve(res.data);
                } else {
                    reject(new Error(res.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((error) => {
                reject(error);
            })
        })
    },
    store(context, data){
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_ADD_DEPARTMENT_INDICADORES', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al crear'));
                }
            }).catch((error) => {
                reject(error)
            })
        });
    },
    update(context, {id, data}){
        return new Promise((resolve, reject) => {
            api.update(id, data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_UPDATE_DEPARTMENT_INDICADORES', resp.data);
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al actualizar'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete(context, id){
        return new Promise((resolve, reject) => {
            api.deleteDeptIndi(id).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_DELETE_DEPARTMENT_INDICADORES', id);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al eliminar'));
                }
            }).catch((error) => {
                reject(error)
            })
        });
    },    
}

const getters = {
    getIndi(state){
        return state.departmentIndicators;
    },
    getIndiNot(state){
        return state.departmentIndicatorsNot;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}